import { SftpSummaryTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { TableCellType, TableHeader } from "../../../custom-table/table";

/**
 * Generates table headers for Response Status tab
 */
export const generateResponseStatusTableData = (): TableHeader[] => {
  return [
    {
      label: "Filename",
      key: SftpSummaryTableColumnKeys.FILENAME,
      order: 1,
      width: 28,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Approved",
      key: SftpSummaryTableColumnKeys.APPROVED_CNT,
      order: 2,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "NAR",
      key: SftpSummaryTableColumnKeys.NAR_CNT,
      order: 3,
      width: 8,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Denied",
      key: SftpSummaryTableColumnKeys.DENIED_CNT,
      order: 4,
      width: 8,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Pending",
      key: SftpSummaryTableColumnKeys.PENDING_CNT,
      order: 5,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "N/A",
      key: SftpSummaryTableColumnKeys.NA_CNT,
      order: 6,
      width: 8,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "No Clinical",
      key: SftpSummaryTableColumnKeys.NO_CLINICAL_CNT,
      order: 7,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Other",
      key: SftpSummaryTableColumnKeys.OTHER_CNT,
      order: 8,
      width: 8,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Total",
      key: SftpSummaryTableColumnKeys.RESPONSE_TOTAL_CNT,
      order: 9,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
  ];
};

/**
 * Generates table headers for Text Notes tab
 */
export const generateTextNotesTableData = (): TableHeader[] => {
  return [
    {
      label: "Filename",
      key: SftpSummaryTableColumnKeys.FILENAME,
      order: 1,
      width: 34,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Success",
      key: SftpSummaryTableColumnKeys.TEXT_SUCCESS_CNT,
      order: 2,
      width: 12,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "In Progress",
      key: SftpSummaryTableColumnKeys.TEXT_PROGRESS_CNT,
      order: 3,
      width: 12,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Error",
      key: SftpSummaryTableColumnKeys.TEXT_ERROR_CNT,
      order: 4,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "N/A",
      key: SftpSummaryTableColumnKeys.TEXT_NA_CNT,
      order: 5,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Not Started",
      key: SftpSummaryTableColumnKeys.TEXT_NOT_STARTED_CNT,
      order: 6,
      width: 12,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Total",
      key: SftpSummaryTableColumnKeys.TEXT_TOTAL_CNT,
      order: 7,
      width: 10,
      type: TableCellType.STRING,
      sortable: true,
    },
  ];
};
